import { render, staticRenderFns } from "./InventarioHistoricoDetallado.vue?vue&type=template&id=9d6313d6&scoped=true"
import script from "./InventarioHistoricoDetallado.vue?vue&type=script&lang=js"
export * from "./InventarioHistoricoDetallado.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./InventarioHistoricoDetallado.vue?vue&type=style&index=1&id=9d6313d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6313d6",
  null
  
)

export default component.exports